// Site-wide image handling for phones:
//  - lazy-load every image except the first screenful (hero / header logo)
//  - ask Cloudinary for an auto-format, auto-quality, right-sized copy
//    instead of the multi-megabyte original
// Done with one MutationObserver so it also covers images that API data
// and sliders render later, without touching every component.

const CLOUDINARY = /^(https?:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\/)(v\d+\/.+)$/;

const targetWidth = () => (window.innerWidth <= 768 ? 800 : 1600);

const isAboveFold = (img) =>
  !!img.closest(".als-slider, header, .header, .consultation-banner, .shop-banner");

const optimise = (img) => {
  if (img.dataset.optimised) return;
  img.dataset.optimised = "1";

  if (!img.hasAttribute("loading") && !isAboveFold(img)) {
    img.loading = "lazy";
  }
  if (!img.hasAttribute("decoding")) img.decoding = "async";

  const match = CLOUDINARY.exec(img.getAttribute("src") || "");
  if (match && !/\.svg(\?.*)?$/i.test(match[2])) {
    img.src = `${match[1]}f_auto,q_auto,w_${targetWidth()}/${match[2]}`;
  }
};

const scan = (root) => {
  if (root.tagName === "IMG") optimise(root);
  if (root.querySelectorAll) root.querySelectorAll("img").forEach(optimise);
};

export function initMobileImages() {
  if (typeof window === "undefined" || !("MutationObserver" in window)) return;

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => {
        if (node.nodeType === 1) scan(node);
      });
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  scan(document.documentElement);
}
